import React, { useState, useEffect, useContext } from "react";

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import avatar from './img/avatar.png'

import './App.css';

const menu = {
  "dashboard": {
    path: "Operación/",
    title: "Dashboard"
  },
  "library": {
    path: "Operación/",
    title: "Librería"
  },
  "shopping": {
    path: "Operación/",
    title: "Compras"
  },
  "remision": {
    path: "Operación/",
    title: "Remisiones de Ingreso"
  },
  "sales": {
    path: "Operación/",
    title: "Ventas"
  },
  "return": {
    path: "Operación/",
    title: "Devoluciones"
  },

  "proveedores": {
    path: "Configuración/",
    title: "Proveedores"
  },
  "editoriales": {
    path: "Configuración/",
    title: "Editoriales"
  },
  "almacenes": {
    path: "Configuración/",
    title: "Almacenes"
  },
  "clientes": {
    path: "Configuración/",
    title: "Clientes"
  },
  "reportes": {
    path: "Configuración/",
    title: "Reporte"
  },
}

function SectionTitle({ section }) {
  const { logged, name, logOut } = useContext(GlobalContext);
  const [ path, setPath ] = useState("")
  const [ title, setTitle ] = useState("")
  const [ userMail, setUserMail ] = useState("")

  useEffect(() => {
  }, []);

  useEffect(() => {
    let selection = menu[section];
    console.log("selection", selection)

    setPath( selection.path )
    setTitle( selection.title )
  }, [ section ]);

  return (
    <>
      
      <div>
        <Container>
          <Row>
            <Col md={ 6 } align="left">
              <div className="section-path">
                { path }
              </div>
              <div className="section-title">
                { title }
              </div>
            </Col>

            <Col md={ 6 } align="right">
              <div className='section-bar' style={ { width: 'fit-content' } }>
                <Container>
                  <Row className="align-items-center">
                    <Col md={ 'auto' } style={{ paddingLeft: 0 }}>
                      <img src={ avatar } className="avatar" />
                    </Col>
                    <Col>
                      <div align='left'>
                        <div className='user'>{ name }</div>
                        <div className='close' onClick={ () => logOut() }>Cerrar sesión</div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </>
  );
}

export default SectionTitle;
